// AuthenticatedRoutes.js - Komponente für authentifizierte Routen
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Employee from '../pages/Employee';
import EmployeeAdministration from '../pages/EmployeeAdministration';
import MyTimes from '../pages/MyTimes';
import Projects from '../pages/Projects';
import TimeManagement from '../pages/TimeManagement';
import Clients from '../pages/Clients';
import Tasks from '../pages/Tasks';
import Export from '../pages/Export';
import Settings from '../pages/Settings';
import Dienstplan from '../pages/Dienstplan';
import Uploads from '../pages/Uploads';
import History from '../pages/History';

/**
 * Komponente zur Verwaltung der authentifizierten Routen
 * 
 * @param {Object} props - Komponenteneigenschaften
 * @param {Function} props.setLoggedIn - Funktion zum Setzen des Login-Status
 */
const AuthenticatedRoutes = ({ setLoggedIn }) => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard setLoggedIn={setLoggedIn} />} />
      <Route path="/home" element={<Dashboard setLoggedIn={setLoggedIn} />} />
      <Route path="/employee" element={<Employee setLoggedIn={setLoggedIn} />} />
      <Route path="/employee-administration" element={<EmployeeAdministration setLoggedIn={setLoggedIn} />} />
      <Route path="/projects" element={<Projects setLoggedIn={setLoggedIn} />} />
      <Route path="/clients" element={<Clients setLoggedIn={setLoggedIn} />} />
      <Route path="/tasks" element={<Tasks setLoggedIn={setLoggedIn} />} />
      <Route path="/myTimes" element={<MyTimes setLoggedIn={setLoggedIn} />} />
      <Route path="/dienstplan" element={<Dienstplan setLoggedIn={setLoggedIn} />} />
      <Route path="/time-management" element={<TimeManagement setLoggedIn={setLoggedIn} />} />
      <Route path="/export" element={<Export setLoggedIn={setLoggedIn} />} />
      <Route path="/settings" element={<Settings setLoggedIn={setLoggedIn} />} />
      <Route path="/uploads" element={<Uploads setLoggedIn={setLoggedIn} />} />
      <Route path="/history" element={<History setLoggedIn={setLoggedIn} />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AuthenticatedRoutes;
